export default {"src":"/_next/static/media/Birthmarks.7d1c1acd.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};